<script lang="ts">
    import { DEFAULT_LAYOUT } from '$lib/components/constants';
    import Text from '../Text.svelte';
    import Answer from './Answer.svelte';
    import Box from '../_wrappers/Box.svelte';
    import clsx from 'clsx';
    import { getBoxAttributes } from '$lib/components/_DisplayComponents/_utils/getBoxAttributes';

    // Types
    import type { TransitionEffect } from '$lib/types/Theme';
    import type { Box as BoxType, Align } from '$lib/types/Components/SharedTypes';
    import type { ComponentProps } from 'svelte';
    import type { RawDraftContentState } from 'draft-js';

    export let align: Align = 'center';
    export let draft: RawDraftContentState;
    export let color = 'black';
    export let box: BoxType;
    export let onAnswerClick: ComponentProps<Answer>['onClick'];
    export let onAnswerMouseEnter: ComponentProps<Answer>['onMouseEnter'];
    export let answers: Omit<ComponentProps<Answer>, 'onClick' | 'onMouseEnter'>[] = [];
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'default';
    export let layout = DEFAULT_LAYOUT;

    const { isInColumn, isInMultiColumn } = layout;

    const textBox: BoxType = {
        top: 'none',
        right: 'none',
        bottom: 'large',
        left: 'none',
    };

    const isEven = answers.length % 2 === 0;

    let answersClasses = clsx('answer grid grid-cols-1 gap-4', {
        'md:grid-cols-2': answers.length % 2 === 0,
    });

    if (isInMultiColumn) {
        answersClasses = 'answer grid grid-cols-1 gap-4 max-w-md mx-auto';
    }
</script>

<Box
    {...getBoxAttributes({ box, isInColumn })}
    {transitionDelay}
    {transitionEffect}
    narrow={!isEven}
>
    <Text {transitionDelay} raw={draft} {align} {color} box={textBox} {layout} />
    <div class={answersClasses}>
        {#each answers as answer}
            <Answer {...answer} onClick={onAnswerClick} onMouseEnter={onAnswerMouseEnter} />
        {/each}
    </div>
</Box>

<style lang="scss">
    .answer :global(h1),
    .answer :global(h2),
    .answer :global(h3),
    .answer :global(h4),
    .answer :global(p) {
        padding: 0 !important;
    }
</style>
